export default __webpack_public_path__ + "static/media/Tadoba-Trails-package.a096ef67.jpg";